// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bbc_a bhe_i bhe_q bhe_j"};